import { render, staticRenderFns } from "./adminVue.vue?vue&type=template&id=2bfc8e05&scoped=true"
import script from "./adminVue.vue?vue&type=script&lang=js"
export * from "./adminVue.vue?vue&type=script&lang=js"
import style0 from "./adminVue.vue?vue&type=style&index=0&id=2bfc8e05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc8e05",
  null
  
)

export default component.exports